import React, { FunctionComponent } from "react";
import styles from "../components/Preview/css/PreviewPage.module.css";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link } from "react-router-dom";

interface IBreadcrumbProps {
  tab?: string;
}

const Breadcrumb: FunctionComponent<IBreadcrumbProps> = ({ tab }) => {
  return (
    <section
      className={styles.breadcrumbContainer}
      style={{
        width: "1180px",
        margin: "auto",
        height: "55px",
        display: "flex",
      }}
    >
      <div className={styles.breadcrumbs}>
        <Link to="/" className={styles.breadcrumbHome}>
          Home
        </Link>
        {tab && <ChevronRightIcon style={{ color: "gray" }} />}
        <Link to="/preview" className={styles.breadcrumbProduct}>
          {tab}
        </Link>
      </div>
    </section>
  );
};

export default Breadcrumb;
